import { Reveal } from "../lib/motion";
import { CHAPTERS, hasLocalImage } from "../lib/data";
import { LocalImage } from "./LocalImage";

export const About = () => (
  <section id="ueber-uns" data-testid="about-section" className="relative py-20 md:py-28 lg:py-36 bg-brand-dark">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-20 items-start">
        <Reveal className="lg:col-span-5 min-w-0">
          <p className="section-eyebrow"><span /> Über uns</p>
          <h2 className="section-heading">
            Dein Tuning – <span className="text-brand">direkt am Fahrzeug.</span>
          </h2>
          <p className="mt-6 text-white/60 leading-relaxed">
            ECU SOLUTIONS verbindet die Arbeit am Fahrzeug mit eigener Softwareentwicklung.
            Vom Alltagsfahrzeug bis zum Performance-Projekt: Wir stimmen die Software auf
            Fahrzeug, Zustand und Einsatzzweck ab. Persönlich für Fahrer, Werkstätten,
            Tuner und Autohäuser.
          </p>
          {hasLocalImage("/ecupic/5.jpeg") && (
            <figure className="mt-9 border border-slate-800 bg-brand-surface">
              <LocalImage src="/ecupic/5.jpeg" alt="Laptop und Programmierinterface bei der Softwarearbeit im BMW"
                width={1152} height={2048} className="w-full aspect-[4/3] sm:aspect-[5/4] object-cover object-[50%_58%]" />
              <figcaption className="flex items-center gap-3 px-5 py-4 font-mono text-[10px] uppercase tracking-wider text-white/60">
                <span className="w-1.5 h-1.5 bg-brand" /> Unsere Arbeit. Direkt vor Ort.
              </figcaption>
            </figure>
          )}
        </Reveal>
        <div className="lg:col-span-7 min-w-0">
          {CHAPTERS.map((chapter, i) => (
            <Reveal key={chapter.no} delay={i * 0.06}>
              <div className="group grid grid-cols-[2.5rem_minmax(0,1fr)] sm:grid-cols-[4rem_minmax(0,1fr)] gap-4 sm:gap-6 py-8 border-t border-white/10 hover:border-brand/50 transition-colors">
                <span className="font-display font-black text-2xl sm:text-4xl text-white/15 group-hover:text-brand transition-colors">{chapter.no}</span>
                <div>
                  <h3 className="font-display font-bold text-lg sm:text-xl text-white leading-snug">{chapter.title}</h3>
                  <p className="mt-4 text-sm sm:text-base text-white/60 leading-relaxed">{chapter.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
